module.exports = __webpack_public_path__ + "img/product2@2x.cd250c79.png";